module.exports = __webpack_public_path__ + "img/nope.fdc0d2a5.jpg";